import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/governance.png'


const _hoisted_1 = { id: "wrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "main-text-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tri-black" }, null, -1)
const _hoisted_5 = { class: "mb-background" }
const _hoisted_6 = { class: "sec" }
const _hoisted_7 = { class: "sec-inner type1" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "content-border cover-blur" }
const _hoisted_11 = { class: "first-content pc" }
const _hoisted_12 = { class: "top" }
const _hoisted_13 = { class: "bottom" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_15 = { class: "top" }
const _hoisted_16 = { class: "bottom" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "VP", -1)
const _hoisted_18 = { class: "top" }
const _hoisted_19 = { class: "bottom" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_21 = { class: "top" }
const _hoisted_22 = { class: "bottom" }
const _hoisted_23 = { class: "top" }
const _hoisted_24 = { class: "bottom" }
const _hoisted_25 = { class: "soon" }
const _hoisted_26 = { class: "type1-mb" }
const _hoisted_27 = { class: "first-content" }
const _hoisted_28 = { class: "top" }
const _hoisted_29 = { class: "bottom" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_31 = { class: "top" }
const _hoisted_32 = { class: "bottom" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "VP", -1)
const _hoisted_34 = { class: "top" }
const _hoisted_35 = { class: "bottom" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "percent" }, "%", -1)
const _hoisted_37 = { class: "first-content two" }
const _hoisted_38 = { class: "top" }
const _hoisted_39 = { class: "bottom" }
const _hoisted_40 = { class: "top" }
const _hoisted_41 = { class: "bottom" }
const _hoisted_42 = { class: "sec-inner type2 agenda" }
const _hoisted_43 = { class: "container" }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tri" }, null, -1)
const _hoisted_46 = { class: "mid-box" }
const _hoisted_47 = { class: "mid-box-check" }
const _hoisted_48 = { class: "text" }
const _hoisted_49 = { class: "mid-box-text" }
const _hoisted_50 = { class: "up-text" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "mid-core row" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tri" }, null, -1)
const _hoisted_56 = { class: "col-6" }
const _hoisted_57 = { class: "progress-area quorum-area test-area" }
const _hoisted_58 = { class: "progress-area" }
const _hoisted_59 = { class: "top-box main" }
const _hoisted_60 = { class: "box1" }
const _hoisted_61 = { class: "id-name" }
const _hoisted_62 = { class: "box2" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "text" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-view-more-white" }, null, -1)
const _hoisted_66 = {
  class: "sec-inner type4",
  id: "guide"
}
const _hoisted_67 = { class: "container" }
const _hoisted_68 = { class: "title" }
const _hoisted_69 = { class: "fourth-content pc" }
const _hoisted_70 = { class: "left" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "right" }
const _hoisted_73 = { class: "top" }
const _hoisted_74 = { class: "mid" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = { class: "bottom" }
const _hoisted_77 = ["href"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-view-more-white" }, null, -1)
const _hoisted_79 = { class: "fourth-content mb" }
const _hoisted_80 = { class: "right" }
const _hoisted_81 = { class: "top" }
const _hoisted_82 = { class: "mid" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = { class: "bottom" }
const _hoisted_85 = ["href"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-view-more-white" }, null, -1)
const _hoisted_87 = { class: "sec-inner type5" }
const _hoisted_88 = { class: "container" }
const _hoisted_89 = { class: "title" }
const _hoisted_90 = { class: "fifth-content row pc" }
const _hoisted_91 = {
  class: "col-4 item no1",
  href: "https://www.artube.video/whitepaper.html#section34",
  target: "_blank"
}
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = { class: "text2" }
const _hoisted_94 = {
  target: "_blank",
  href: "https://market.artube.video/",
  class: "col-4 item no2"
}
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = { class: "text2" }
const _hoisted_97 = {
  target: "_blank",
  href: "https://www.artube.video/Event",
  class: "col-4 item no3"
}
const _hoisted_98 = ["innerHTML"]
const _hoisted_99 = { class: "text2" }
const _hoisted_100 = {
  target: "_blank",
  href: "https://www.artube.video/DailyToon",
  class: "col-4 item no1"
}
const _hoisted_101 = ["innerHTML"]
const _hoisted_102 = { class: "text2" }
const _hoisted_103 = {
  target: "_blank",
  href: "https://www.artube.video/League",
  class: "col-4 item no2"
}
const _hoisted_104 = ["innerHTML"]
const _hoisted_105 = { class: "text2" }
const _hoisted_106 = {
  target: "_blank",
  href: "https://github.com/artube-github",
  class: "col-4 item no3"
}
const _hoisted_107 = ["innerHTML"]
const _hoisted_108 = { class: "text2" }
const _hoisted_109 = { class: "fifth-content mb" }
const _hoisted_110 = {
  target: "_blank",
  href: "https://www.artube.video/whitepaper.html#section34",
  class: "item no1"
}
const _hoisted_111 = ["innerHTML"]
const _hoisted_112 = { class: "text2" }
const _hoisted_113 = {
  target: "_blank",
  href: "https://market.artube.video/",
  class: "col-4 item no2"
}
const _hoisted_114 = ["innerHTML"]
const _hoisted_115 = { class: "text2" }
const _hoisted_116 = {
  target: "_blank",
  href: "https://www.artube.video/Event",
  class: "col-4 item no3"
}
const _hoisted_117 = ["innerHTML"]
const _hoisted_118 = { class: "text2" }
const _hoisted_119 = {
  target: "_blank",
  href: "https://www.artube.video/DailyToon",
  class: "col-4 item no1"
}
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = { class: "text2" }
const _hoisted_122 = {
  target: "_blank",
  href: "https://www.artube.video/League",
  class: "col-4 item no2"
}
const _hoisted_123 = ["innerHTML"]
const _hoisted_124 = { class: "text2" }
const _hoisted_125 = {
  target: "_blank",
  href: "https://github.com/artube-github",
  class: "col-4 item no3"
}
const _hoisted_126 = ["innerHTML"]
const _hoisted_127 = { class: "text2" }
const _hoisted_128 = { class: "footer-plus" }
const _hoisted_129 = { class: "sec-inner type6" }
const _hoisted_130 = { class: "container" }
const _hoisted_131 = { class: "end" }
const _hoisted_132 = { class: "title" }
const _hoisted_133 = { class: "sixth-content row pc" }
const _hoisted_134 = { class: "left col-6" }
const _hoisted_135 = ["src"]
const _hoisted_136 = { class: "right col-6" }
const _hoisted_137 = { class: "sub" }
const _hoisted_138 = { class: "text" }
const _hoisted_139 = ["href"]
const _hoisted_140 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tri" }, null, -1)
const _hoisted_141 = { class: "sixth-content mb" }
const _hoisted_142 = { class: "item" }
const _hoisted_143 = { class: "left" }
const _hoisted_144 = ["src"]
const _hoisted_145 = { class: "right" }
const _hoisted_146 = { class: "sub" }
const _hoisted_147 = { class: "text" }
const _hoisted_148 = ["href"]
const _hoisted_149 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-tri" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { initConnected: _ctx.setConnected }, null, 8, ["initConnected"]),
    _createElementVNode("section", {
      class: _normalizeClass(["main-visual", [this.i18n.locale === 'kr' ? 'on' : '']])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveGuide())),
          class: "how-vote"
        }, [
          _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.howtovote")) + " ", 1),
          _hoisted_4
        ])
      ])
    ], 2),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.i18n.t("landing.governance_stats")), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("ul", _hoisted_11, [
                _createElementVNode("li", null, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.i18n.t("landing.att_tvl")), 1),
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.totalStaking)), 1),
                    _hoisted_14
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.i18n.t("landing.active_votingpower")), 1),
                  _createElementVNode("p", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.totalVp)), 1),
                    _hoisted_17
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.i18n.t("landing.staking_expected_apr")), 1),
                  _createElementVNode("p", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.apr)), 1),
                    _hoisted_20
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.i18n.t("landing.active_agenda")), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.agendaTotal)), 1)
                ]),
                _createElementVNode("li", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/forum'))),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.i18n.t("landing.forum")), 1),
                  _createElementVNode("p", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.i18n.t("landing.gotoforum")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.i18n.t("landing.att_tvl")), 1),
                    _createElementVNode("p", _hoisted_29, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.totalStaking)), 1),
                      _hoisted_30
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.i18n.t("landing.active_votingpower")), 1),
                    _createElementVNode("p", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.totalVp)), 1),
                      _hoisted_33
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.i18n.t("landing.staking_expected_apr")), 1),
                    _createElementVNode("p", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.apr)), 1),
                      _hoisted_36
                    ])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_37, [
                  _createElementVNode("li", null, [
                    _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.i18n.t("landing.active_agenda")), 1),
                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$filters.comma(_ctx.stakingSimpleData.agendaTotal)), 1)
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/forum'))),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.i18n.t("landing.forum")), 1),
                    _createElementVNode("p", _hoisted_41, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.i18n.t("landing.gotoforum")), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("h2", _hoisted_44, [
              _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.active_polls")) + " ", 1),
              _createVNode(_component_router_link, { to: "/agenda" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.view_all")), 1),
                  _hoisted_45
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ui_grid, {
              class: "demo-grid max-width agenda-box",
              position: "left"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agendaList, (data, i) => {
                  return (_openBlock(), _createBlock(_component_ui_grid_cell, {
                    class: "demo-cell cover-blur",
                    columns: "6",
                    key: i
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("p", {
                            class: _normalizeClass({
                                                pendingc: data.state === 0,
                                                notquoromc: data.state === 1,
                                                proceedc: data.state === 2,
                                                approvedc: data.state === 3,
                                                completedc: data.state === 4,
                                                rejectionc: data.state === 5,
                                            })
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["icon", {
                                                    pending: data.state === 0,
                                                    notquorom: data.state === 1,
                                                    proceed: data.state === 2,
                                                    approved: data.state === 3,
                                                    completed: data.state === 4,
                                                    rejection: data.state === 5,
                                                }])
                            }, null, 2),
                            _createTextVNode(_toDisplayString(data.stateNm), 1)
                          ], 2),
                          _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.i18n.t("landing.posted")) + " " + _toDisplayString(data.posted) + " " + _toDisplayString(_ctx.i18n.t("landing.utc")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("p", _hoisted_50, _toDisplayString(data.title), 1),
                          _createElementVNode("p", {
                            class: "sub-text",
                            innerHTML: data.message.replaceAll('\r\n', '').replace('<br />', '').replace('<br />', '')
                          }, null, 8, _hoisted_51),
                          _createElementVNode("p", {
                            innerHTML: data.hashtag
                          }, null, 8, _hoisted_52)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", {
                            class: "more col-6",
                            onClick: ($event: any) => (_ctx.agendaDetailPush(data))
                          }, [
                            _createElementVNode("a", null, [
                              _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.view_detail")) + " ", 1),
                              _hoisted_55
                            ])
                          ], 8, _hoisted_54),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.quorumItem, (quorum) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "quorum-bar",
                                  key: quorum
                                }, [
                                  _createElementVNode("p", {
                                    class: "text",
                                    style: _normalizeStyle({ left: quorum.percent + '%' })
                                  }, _toDisplayString(_ctx.i18n.t("landing.quorum")) + " " + _toDisplayString(data.quorum) + " %", 5),
                                  _createElementVNode("p", {
                                    class: "arrow",
                                    style: _normalizeStyle({ left: quorum.percent2 + '%' })
                                  }, null, 4)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.progressItem, (progress) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "progress-item",
                                  key: progress,
                                  style: _normalizeStyle({ 'background-color': progress.color, width: progress.percent + '%' })
                                }, _toDisplayString(progress.pro), 5))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("agenda.id")) + " " + _toDisplayString(data.idx), 1),
                          _createElementVNode("span", null, _toDisplayString(data.ctName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.vote")) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(data.turnout) + " %", 1)
                          ]),
                          _createElementVNode("div", {
                            class: "block",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.snapShotBlockNumber(data.blockNumber))
                          }, [
                            _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.i18n.t("landing.start_block")), 1),
                            _createElementVNode("span", null, [
                              _createTextVNode("# " + _toDisplayString(data.blockNumber) + " ", 1),
                              _hoisted_65
                            ])
                          ], 8, _hoisted_63)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("h2", _hoisted_68, _toDisplayString(_ctx.i18n.t("landing.message_1")), 1),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guideList, (data, i) => {
                  return (_openBlock(), _createElementBlock("ul", { key: i }, [
                    _createElementVNode("li", {
                      onClick: ($event: any) => (_ctx.changeSubTab(i)),
                      class: _normalizeClass([_ctx.selectedSubTab === i ? 'on' : ''])
                    }, _toDisplayString(data.title), 11, _hoisted_71)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.guideData.title), 1)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.guideData.message
                  }, null, 8, _hoisted_75)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("a", {
                    href: _ctx.guideData.link,
                    target: "_blank"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.guideData.linkName) + " ", 1),
                    _hoisted_78
                  ], 8, _hoisted_77)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_Swiper, {
                  autoplay: { delay: 55000, disableOnInteraction: false },
                  pagination: { clickable: false },
                  modules: _ctx.swiperModules,
                  class: "mySwiper"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guideList, (data, i) => {
                      return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("h3", null, _toDisplayString(data.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("p", {
                              innerHTML: data.message
                            }, null, 8, _hoisted_83)
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("a", {
                              href: data.link,
                              target: "_blank"
                            }, [
                              _createTextVNode(_toDisplayString(data.linkName) + " ", 1),
                              _hoisted_86
                            ], 8, _hoisted_85)
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modules"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("h2", _hoisted_89, _toDisplayString(_ctx.i18n.t("landing.resources")), 1),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("a", _hoisted_91, [
                _createElementVNode("p", {
                  class: "text",
                  innerHTML: _ctx.i18n.t('landing.message_2')
                }, null, 8, _hoisted_92),
                _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.i18n.t("landing.message_3")), 1)
              ]),
              _createElementVNode("a", _hoisted_94, [
                _createElementVNode("p", {
                  class: "text",
                  innerHTML: _ctx.i18n.t('landing.message_4')
                }, null, 8, _hoisted_95),
                _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.i18n.t("landing.message_5")), 1)
              ]),
              _createElementVNode("a", _hoisted_97, [
                _createElementVNode("p", {
                  class: "text",
                  innerHTML: _ctx.i18n.t('landing.message_6')
                }, null, 8, _hoisted_98),
                _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.i18n.t("landing.message_7")), 1)
              ]),
              _createElementVNode("a", _hoisted_100, [
                _createElementVNode("p", {
                  class: "text",
                  innerHTML: _ctx.i18n.t('landing.message_8')
                }, null, 8, _hoisted_101),
                _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.i18n.t("landing.message_9")), 1)
              ]),
              _createElementVNode("a", _hoisted_103, [
                _createElementVNode("p", {
                  class: "text",
                  innerHTML: _ctx.i18n.t('landing.message_10')
                }, null, 8, _hoisted_104),
                _createElementVNode("p", _hoisted_105, _toDisplayString(_ctx.i18n.t("landing.message_11")), 1)
              ]),
              _createElementVNode("a", _hoisted_106, [
                _createElementVNode("p", {
                  class: "text",
                  innerHTML: _ctx.i18n.t('landing.message_12')
                }, null, 8, _hoisted_107),
                _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.i18n.t("landing.message_13")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_109, [
              _createVNode(_component_Swiper, {
                autoplay: { delay: 55000, disableOnInteraction: false },
                pagination: { clickable: false },
                modules: _ctx.swiperModules,
                class: "mySwiper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_110, [
                        _createElementVNode("p", {
                          class: "text",
                          innerHTML: _ctx.i18n.t('landing.message_2')
                        }, null, 8, _hoisted_111),
                        _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.i18n.t("landing.message_3")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_113, [
                        _createElementVNode("p", {
                          class: "text",
                          innerHTML: _ctx.i18n.t('landing.message_4')
                        }, null, 8, _hoisted_114),
                        _createElementVNode("p", _hoisted_115, _toDisplayString(_ctx.i18n.t("landing.message_5")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_116, [
                        _createElementVNode("p", {
                          class: "text",
                          innerHTML: _ctx.i18n.t('landing.message_6')
                        }, null, 8, _hoisted_117),
                        _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.i18n.t("landing.message_7")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_119, [
                        _createElementVNode("p", {
                          class: "text",
                          innerHTML: _ctx.i18n.t('landing.message_8')
                        }, null, 8, _hoisted_120),
                        _createElementVNode("p", _hoisted_121, _toDisplayString(_ctx.i18n.t("landing.message_9")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_122, [
                        _createElementVNode("p", {
                          class: "text",
                          innerHTML: _ctx.i18n.t('landing.message_10')
                        }, null, 8, _hoisted_123),
                        _createElementVNode("p", _hoisted_124, _toDisplayString(_ctx.i18n.t("landing.message_11")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SwiperSlide, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_125, [
                        _createElementVNode("p", {
                          class: "text",
                          innerHTML: _ctx.i18n.t('landing.message_12')
                        }, null, 8, _hoisted_126),
                        _createElementVNode("p", _hoisted_127, _toDisplayString(_ctx.i18n.t("landing.message_13")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modules"])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_128, [
        _createElementVNode("div", _hoisted_129, [
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.i18n.t("landing.message_14")), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.i18n.t("landing.message_15")), 1)
            ]),
            _createElementVNode("h2", _hoisted_132, _toDisplayString(_ctx.i18n.t("landing.relevant_blog_posts")), 1),
            _createElementVNode("div", _hoisted_133, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forumPostList, (data, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item row col-6 cover-blur",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("img", {
                      src: data.imgUrl,
                      alt: ""
                    }, null, 8, _hoisted_135)
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("p", _hoisted_137, _toDisplayString(data.name), 1),
                    _createElementVNode("p", _hoisted_138, _toDisplayString(data.desc), 1),
                    _createElementVNode("a", {
                      href: data.link,
                      target: "_blank"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.view_post")), 1),
                      _hoisted_140
                    ], 8, _hoisted_139)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_141, [
              _createVNode(_component_Swiper, {
                autoplay: { delay: 55000, disableOnInteraction: false },
                pagination: { clickable: false },
                modules: _ctx.swiperModules,
                class: "mySwiper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forumPostList, (data, i) => {
                    return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("div", _hoisted_143, [
                            _createElementVNode("img", {
                              src: data.imgUrl,
                              alt: ""
                            }, null, 8, _hoisted_144)
                          ]),
                          _createElementVNode("div", _hoisted_145, [
                            _createElementVNode("p", _hoisted_146, _toDisplayString(data.name), 1),
                            _createElementVNode("p", _hoisted_147, _toDisplayString(data.desc), 1),
                            _createElementVNode("a", {
                              href: data.link,
                              target: "_blank"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.i18n.t("landing.view_post")), 1),
                              _hoisted_149
                            ], 8, _hoisted_148)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules"])
            ])
          ])
        ]),
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}